import axios from 'axios'

export default axios.create({
    baseURL: 'https://lppsecureapi.lpn.co.th/api/'
})